import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { BreadcrumbProps } from './RouteProps';
import { Chip, Box, useMediaQuery, useTheme } from '@mui/material';

const CustomBreadcrumbs = ({ routes }: BreadcrumbProps) => {
  const location = useLocation();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md')); // Hide on 'sm' and 'md' screens

  if (isSmallScreen) return null; // Do not render Breadcrumbs on small & medium screens

  let shouldRenderNextBreadcrumb = true;
  const pathSegments = decodeURIComponent(location.pathname.toLowerCase())
    .split('/')
    .filter((segment) => segment);

  const regex = /\/keyvault\/(.+)/;
  const shouldRenderSecureKeyBreadcrumb = regex.test(
    location.pathname.toLowerCase(),
  );

  return (
    <Box
      sx={{
        maxWidth: '100%',
        overflowX: 'auto',
        whiteSpace: 'nowrap',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          overflow: 'hidden',
        }}
      >
        <Link to="/" style={{ textDecoration: 'none' }}>
          <Chip color="secondary" label="Home" sx={{ fontSize: '14px' }} />
        </Link>
        {pathSegments.map((segment, index) => {
          const isLastSegment = index === pathSegments.length - 1;
          const url = `/${pathSegments.slice(0, index + 1).join('/')}`;

          const route = routes.find((route) => {
            const routePath = route.path.toLowerCase();
            if (routePath.includes(':')) {
              const pathWithParamReplaced = routePath.replace(
                /:\w+/g,
                (param) => {
                  const paramIndex = routePath.split('/').indexOf(param);
                  return pathSegments[paramIndex - 1];
                },
              );
              return pathWithParamReplaced === url;
            }
            return routePath === url;
          });

          if (!route) return null;

          let breadcrumbLabel = route.name;
          if (
            route.path.includes(':Operation') &&
            !route.path.includes(':KeyName')
          ) {
            shouldRenderNextBreadcrumb = false;
            breadcrumbLabel = 'Secure Key Operation';
          }

          if (shouldRenderNextBreadcrumb) {
            return isLastSegment ? (
              <Typography
                key={url}
                sx={{
                  fontSize: '14px',
                  color: 'white',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {breadcrumbLabel}
              </Typography>
            ) : (
              <Link to={url} key={url} style={{ textDecoration: 'none' }}>
                <Chip
                  color="secondary"
                  label={breadcrumbLabel}
                  sx={{ fontSize: '14px' }}
                />
              </Link>
            );
          }
          return null;
        })}
        {shouldRenderSecureKeyBreadcrumb && (
          <Typography
            key="secure-key-operation"
            sx={{ fontSize: '14px', color: 'white' }}
          >
            Secure Key Operation
          </Typography>
        )}
      </Breadcrumbs>
    </Box>
  );
};

export default CustomBreadcrumbs;
